/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import Loader from '../../common/Loader';
import Odd from '../../common/Odd';
import { useFetchWidgets } from '../../data/fetchWidgets';
import { getNumberOfColsMobile } from '../../data/utils/getNumberOfColsMobile';
import { iconCategoryCssClass } from '../../data/utils/iconCategoryCssClass';
import { iconSportCssClass } from '../../data/utils/iconSportCssClass';
import { labels } from '../../data/labels';
import { PrematchContext } from '../Prematch';

function TopMatch(props) {
    const prematchContext = React.useContext(PrematchContext);
    const [data, setData] = useState(prematchContext.cache.widgets);
    const fetchData = data == null;
    const [state] = useFetchWidgets(fetchData);

    useEffect(() => {
        if (fetchData && !state.isLoading && !state.isError) {
            prematchContext.cache.widgets = state.data;
            setData(state.data);
        }
    }, [state]);

    if (!data) {
        return <Loader error={state.isError} />;
    }

    return (
        <div id="avvenimenti">
            <span className="list-heading">{labels['prematch.top_matches'] || 'Top Match'}</span>
            {data?.topMatches?.map((match, i) => {
                const uniqueId = `${match.sportRef}_${match.categoryRef}_${match.tournamentRef}`;
                const iconClass = props.data?.tournamentByUniqueId[uniqueId].iconClass ?? null;
                const icoCategory = iconCategoryCssClass(match.sportRef, match.categoryRef, iconClass);
                const odds = match.scommessa.odds;
                return (
                    <div id={`top-match-event-${uniqueId}_${match.id}`} key={i}>
                        <div className="heading text-medium cg-flex">
                            <div className={`sport-img ${iconSportCssClass(match.sportRef)}`}></div>
                            <span className="push-left push-right">{match.tournamentDesc}</span>
                            <div className={`prematch-sport-img big ${icoCategory}`}></div>
                        </div>
                        <a className="info-avvenimento">
                            <div className="nome-avvenimento">
                                <span className="text-small">{match.team1}</span>
                                <span className="text-small">{match.team2}</span>
                            </div>
                            <span className="ora-avvenimento text-small push-right">{match.date}</span>
                        </a>
                        <div className={"esiti-container grid-columns-" + getNumberOfColsMobile(odds.length)}>
                            {odds.map(odd =>
                                <Odd key={odd.id} {...odd} />
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

export default TopMatch;